import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import { message } from 'antd';
import './Login.css';
import AuthForm from './AuthForm';
import { AuthRole, RoleBar, RoleTiles } from './RoleTiles';

interface MenuLoginProps {
  visible: boolean;
  loading: boolean;
  onCancel: () => void;
  onRegister: () => void;
  /** Kept for existing callers; the role is now always picked from the tiles first. */
  defaultTab?: AuthRole;
  /** Skip the role tiles and log in as a student only. */
  studentOnly?: boolean;
  /** Where to go after a successful login instead of the dashboard. */
  redirectAfterLogin?: string;
}

const MenuLogin: React.FC<MenuLoginProps> = ({ visible, loading, onCancel, onRegister, studentOnly = false, redirectAfterLogin }) => {
  const [pickedRole, setPickedRole] = useState<AuthRole | null>(null);
  // studentOnly can flip on right as the modal opens, so it is applied on every render rather than stored.
  const role: AuthRole | null = studentOnly ? 'student' : pickedRole;

  // Every time the modal is closed, start over at the role tiles.
  useEffect(() => {
    if (!visible) setPickedRole(null);
  }, [visible]);

  const chooseRole = (key: AuthRole) => {
    // AuthForm starts from the stored tab, so keep it in step with the tile that was clicked.
    localStorage.setItem('activeTab', key);
    setPickedRole(key);
  };

  const changeRole = () => {
    localStorage.removeItem('activeTab');
    setPickedRole(null);
  };

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      className="login-widget-modal"
      width={780}
    >
      <div className="login-widget-container">
        {role === null ? (
          <RoleTiles title="Welcome to enpropeL" subtitle="Choose how you want to sign in" onSelect={chooseRole} />
        ) : (
          <>
            {!studentOnly && <RoleBar role={role} onBack={changeRole} />}
            <AuthForm
              key={role}
              mode="login"
              defaultTab={role}
              showTabs={false}
              redirectAfterLogin={redirectAfterLogin}
              onSuccess={() => {
                message.success('Login successful! Redirecting to dashboard...');
                onCancel();
              }}
              className="login-widget-form"
            />
          </>
        )}

        <div className="login-widget-footer">
          <span>Don't have an account? </span>
          <Button type="link" onClick={onRegister} className="register-link-btn">
            Register
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MenuLogin;
